import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import JBImage from 'components/essentials/JBImage';
import JBResponsiveImage from 'components/essentials/JBResponsiveImage';
import BannerTextSection from './BannerTextSection';
import definition from './definition.yaml';
const ImageWithTextBanner2 = t0 => {
  const $ = _c(51);
  const {
    config: t1,
    isFullHeight: t2,
    isHomepage: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const config = t4;
  const isFullHeight = t2 === undefined ? false : t2;
  const isHomepage = t3 === undefined ? false : t3;
  const [isBannerImageLoaded, setIsBannerImageLoaded] = useState(false);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsBannerImageLoaded(true);
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const onImageLoad = t5;
  const {
    imageProps,
    alignment: t6,
    textContent,
    colors,
    ctaColors: t7,
    toggleInputType,
    cta
  } = config;
  const alignment = t6 === undefined ? "left" : t6;
  let t8;
  if ($[3] !== t7) {
    t8 = t7 === undefined ? {} : t7;
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const ctaColors = t8;
  const colorsBackgroundHex = colors?.backgroundHex ?? definition.props.colors.backgroundHex;
  const imageAltTitle = imageProps?.altTitle ?? definition.props.imageProps.altTitle;
  const imageSrcUltraWide = imageProps?.src ?? definition.props.imageProps.src;
  const imageSrcExtraWide = imageProps?.srcExtraWide ?? imageSrcUltraWide;
  const imageSrcSquare = imageProps?.srcSquare ?? imageSrcUltraWide;
  const imageSrcWide = imageProps?.srcWide ?? imageSrcUltraWide;
  const t9 = !isBannerImageLoaded;
  const t10 = alignment === "left";
  const t11 = alignment === "right";
  let t12;
  if ($[5] !== isFullHeight || $[6] !== t10 || $[7] !== t11 || $[8] !== t9) {
    t12 = cx("flex overflow-hidden flex-col items-stretch lg:h-[560px] [&_h1]:lg:max-w-[700px] 2xl:h-full 2xl:items-center", {
      "!bg-white": t9,
      "lg:flex-row-reverse": t10,
      "lg:flex-row": t11,
      "md:h-full lg:h-full": isFullHeight
    });
    $[5] = isFullHeight;
    $[6] = t10;
    $[7] = t11;
    $[8] = t9;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== colorsBackgroundHex) {
    t13 = {
      backgroundColor: colorsBackgroundHex
    };
    $[10] = colorsBackgroundHex;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== imageAltTitle || $[13] !== imageSrcExtraWide) {
    t14 = !!imageSrcExtraWide && <JBImage alt={imageAltTitle} ar="2:1" auto="format,compress" className="block h-[50vw] object-cover w-full lg:h-full lg:w-full" crop="center" lazy={false} media="(max-width: 1023px)" onLoad={onImageLoad} renderAsSource={true} sizes="100vw" src={imageSrcExtraWide} />;
    $[12] = imageAltTitle;
    $[13] = imageSrcExtraWide;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== imageAltTitle || $[16] !== imageSrcSquare) {
    t15 = !!imageSrcSquare && <JBImage alt={imageAltTitle} ar="1:1" auto="format,compress" className="block h-[50vw] object-cover w-full lg:h-full lg:w-full" crop="center" lazy={false} media="(min-width: 1024px) and (max-width: 1151px)" onLoad={onImageLoad} renderAsSource={true} sizes="50vw" src={imageSrcSquare} />;
    $[15] = imageAltTitle;
    $[16] = imageSrcSquare;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== imageAltTitle || $[19] !== imageSrcWide) {
    t16 = !!imageSrcWide && <JBImage alt={imageAltTitle} ar="3:2" auto="format,compress" className="block h-[50vw] object-cover w-full lg:h-full lg:w-full" lazy={false} media="(min-width: 1152px) and (max-width: 1440px)" onLoad={onImageLoad} renderAsSource={true} sizes="60vw" src={imageSrcWide} />;
    $[18] = imageAltTitle;
    $[19] = imageSrcWide;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== imageAltTitle || $[22] !== imageSrcExtraWide) {
    t17 = !!imageSrcExtraWide && <JBImage alt={imageAltTitle} ar="2:1" auto="format,compress" className="block h-[50vw] object-cover w-full lg:h-full lg:w-full" lazy={false} media="(min-width: 1441px) and (max-width: 1799px)" onLoad={onImageLoad} renderAsSource={true} sizes="68vw" src={imageSrcExtraWide} />;
    $[21] = imageAltTitle;
    $[22] = imageSrcExtraWide;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== imageAltTitle || $[25] !== imageSrcUltraWide) {
    t18 = !!imageSrcUltraWide && <JBImage alt={imageAltTitle} auto="format,compress" className="block h-[50vw] object-cover w-full lg:h-full lg:w-full" lazy={false} media="(min-width: 1800px)" onLoad={onImageLoad} renderAsSource={true} sizes="75vw" src={imageSrcUltraWide} />;
    $[24] = imageAltTitle;
    $[25] = imageSrcUltraWide;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== imageAltTitle || $[28] !== imageSrcWide) {
    t19 = !!imageSrcWide && <JBImage alt={imageAltTitle} auto="format,compress" className="block h-[50vw] object-cover w-full lg:h-full lg:w-full" lazy={false} onLoad={onImageLoad} sizes="60vw" src={imageSrcWide} width={1} />;
    $[27] = imageAltTitle;
    $[28] = imageSrcWide;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t14 || $[31] !== t15 || $[32] !== t16 || $[33] !== t17 || $[34] !== t18 || $[35] !== t19) {
    t20 = <div className="relative flex-1 lg:h-full lg:w-full"><JBResponsiveImage>{t14}{t15}{t16}{t17}{t18}{t19}</JBResponsiveImage></div>;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== colors || $[38] !== cta || $[39] !== ctaColors || $[40] !== textContent || $[41] !== toggleInputType) {
    t21 = {
      textContent,
      colors,
      cta,
      ctaColors,
      toggleInputType
    };
    $[37] = colors;
    $[38] = cta;
    $[39] = ctaColors;
    $[40] = textContent;
    $[41] = toggleInputType;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== isHomepage || $[44] !== t21) {
    t22 = <BannerTextSection config={t21} isHomepage={isHomepage} className="2xl:!h-[revert] 2xl:!self-stretch" />;
    $[43] = isHomepage;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t12 || $[47] !== t13 || $[48] !== t20 || $[49] !== t22) {
    t23 = <div className={t12} style={t13}>{t20}{t22}</div>;
    $[46] = t12;
    $[47] = t13;
    $[48] = t20;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
};
ImageWithTextBanner2.propTypes = {
  config: PropTypes.shape({
    colors: PropTypes.object,
    cta: PropTypes.object,
    ctaColors: PropTypes.object,
    textContent: PropTypes.object,
    toggleInputType: PropTypes.object
  }),
  isFullHeight: PropTypes.bool,
  isHomepage: PropTypes.bool
};
export default React.memo(ImageWithTextBanner2);